function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 4a2 2 0 012-2h8a2 2 0 012 2H6v14a2 2 0 01-2-2V4zm6 4v12h8V8h-8zm0-2h8a2 2 0 012 2v12a2 2 0 01-2 2h-8a2 2 0 01-2-2V8a2 2 0 012-2z"
});

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _ref);
};

export default SvgCopy;